import { render, staticRenderFns } from "./VideoSurveillance.vue?vue&type=template&id=4ee356a2&scoped=true&"
import script from "./VideoSurveillance.vue?vue&type=script&lang=js&"
export * from "./VideoSurveillance.vue?vue&type=script&lang=js&"
import style0 from "./VideoSurveillance.vue?vue&type=style&index=0&id=4ee356a2&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee356a2",
  null
  
)

export default component.exports